/* eslint-disable no-use-before-define */

define('side-menu/side-menu',['require','exports','module','durandal/app','knockout','plugins/router','steps-side-menu','api-access','lib/auth/auth','lib/progress-component/percent-complete','mixpanel-helper','user-agent','lodash','i18next','knockout-bind-react'],function (require, exports, module) {
    var app = require('durandal/app');
    var ko = require('knockout');
    var router = require('plugins/router');
    var SideMenu = require('steps-side-menu');
    var apiAccess = require('api-access');
    var auth = require('lib/auth/auth');
    var getPercentCompleted = require('lib/progress-component/percent-complete');
    var mixpanelHelper = require('mixpanel-helper');
    var ua = require('user-agent')();
    var _ = require('lodash');
    var i18n = require('i18next');

    require('knockout-bind-react');

    module.exports = function () {
        var self = this;

        self.isShown = ko.observable(false);
        self.steps = ko.observable();

        var show = function () {
            self.isShown(true);
            app.trigger('sideMenu:shown');
        };

        var hide = function () {
            self.isShown(false);
            app.trigger('sideMenu:hidden');
        };

        var toggle = function () {
            if (self.isShown()) {
                hide();
            } else {
                show();
            }
        };

        var handleClose = function () {
            toggle();
            mixpanelHelper.track('Click to Close GSU Menu');
        };

        self.reactOptions = ko.computed(function () {
            return {
                component: SideMenu.default,
                props: {
                    title: i18n.t('welcome.start'),
                    handleClose: handleClose,
                    isShown: self.isShown(),
                    steps: self.steps(),
                    track: mixpanelHelper.track,
                    isMac: ua.os.simpleName === 'mac',
                    isWindows: ua.os.simpleName === 'windows',
                    locale: i18n.lng()
                }
            };
        });

        var savedSettings = [];

        function mixpanelTrack(settingKey) {
            var eventKeyMapping = {
                hasScheduledMeeting: 'Complete GSU Step: Schedule',
                hasExploredAudioOptions: 'Complete GSU Step: Explore Audio',
                hasStartedMeeting: 'Complete GSU Step: Test Meeting',
                hasIntegratedCalendar: 'Complete GSU Step: Calendar Integrations'
            };

            if (settingKey === 'hasScheduledMeeting' || settingKey === 'hasStartedMeeting') {
                mixpanelHelper.track(eventKeyMapping[settingKey], {'GSU Active': self.isShown()});
            } else {
                mixpanelHelper.track(eventKeyMapping[settingKey]);
            }
        }

        function saveAsComplete(settingKey) {
            apiAccess.user.settings()
                .then(function (userSettings) {
                    if (userSettings.isGSUEnabled && !userSettings[settingKey]) {
                        var settings = {};
                        settings[settingKey] = true;
                        apiAccess.user.updateSettings(settings)
                            .then(updateProps)
                            .fail(function () { /* Do nothing */ });

                        if (!_.includes(savedSettings, settingKey)) {
                            // Keep a local cache for tracked settings, to prevent repeated events.
                            savedSettings.push(settingKey);

                            mixpanelTrack(settingKey);
                        }
                    }
                })
                .fail(function () { /* Do nothing */ });
        }

        function updateProps() {
            /**
             * A bug exists in api-access where multiple GET requests made in sequence around a PUT request
             * causes the cache to get stale.
             *
             * Clear the cache before the user settings request as a workaround.
             */
            apiAccess.cors.clearCache();

            var settingsRequest = apiAccess.user.settings();

            return $.when(settingsRequest, getPercentCompleted())
                .then(function (settingsResponse, percent) {
                    if (percent === 100) {
                        apiAccess.user.updateSettings({hasCompletedGSU: true});
                    }
                    app.trigger('flags:updated', percent);

                    var configureOptions = {
                        hasPersonalRoom: true,
                        userSettings: settingsResponse[0],
                        complete: saveAsComplete
                    };

                    self.steps(SideMenu.configure.stepStates(configureOptions));
                });
        }

        function showInitially() {
            var composingMeetingHeader = $.Deferred();
            var enablingGSU = $.Deferred();
            app.on('meetingsHeader:completedComposing', composingMeetingHeader.resolve);
            app.on('GSU:Enabled', enablingGSU.resolve);
            $.when(composingMeetingHeader, enablingGSU).then(show);
        }

        router.on('router:navigation:processing', function (activeInstruction) {
            if (activeInstruction.config.id !== 'meetings') {
                hide();
            }
        });

        var notify = function (message) {
            SideMenu.configure.notify({
                isShown: self.isShown(),
                message: message
            });
        };

        app.on('progress:clicked', function () {
            toggle();

            if (self.isShown()) {
                mixpanelHelper.track('Click to Open GSU Menu');
            } else {
                mixpanelHelper.track('Click to Close GSU Menu');
            }
        });

        app.on('g2mmUrl:reserved', updateProps);
        app.on('navbar:menu-clicked', hide);

        app.on('scheduleModal:shown', function () { notify('scheduleModal:shown') });
        app.on('scheduleModal:canceled', function () { notify('scheduleModal:canceled') });
        app.on('scheduleModal:meetingNameFocused', function () { notify('scheduleModal:meetingNameFocused') });
        app.on('inviteModal:shown', function () { notify('inviteModal:shown') });
        app.on('inviteModal:clickedTextAction', function () { notify('inviteModal:clickedTextAction') });

        app.on('meeting:scheduled', function () { saveAsComplete('hasScheduledMeeting') });
        app.on('meeting:launched', function () { saveAsComplete('hasStartedMeeting') });

        self.activate = function () {
            if (auth.getToken()) {
                showInitially();
                return updateProps();
            }
            return undefined;
        };
    };
});

